<template>
  <!-- MASTER HEADER -->
  <header class="master-header">
    <!-- TOPBAR -->
    <div class="topbar">
      <ul class="quick-links skip-links">
        <li class="border-right">
          <a v-bind:href="'#/'" class="tfcc-title"
            >Ealing Trailfinders Cricket Club</a
          >
        </li>
        <li class="">
          <a v-scroll-to="'#main'" class="btn-scroll has-icon-right"
            >Skip to main <i class="material-icons">format_align_left</i></a
          >
        </li>
      </ul>

      <ul class="quick-links">
        <!-- Social -->
        <li class="d-none">
          <a href="#" target="_blank" class=""
            ><i class="zmdi zmdi-instagram"
          /></a>
        </li>
        <li class="">
          <a
            href="https://www.facebook.com/groups/686811417998126"
            target="_blank"
            class=""
            ><i class="zmdi zmdi-facebook"
          /></a>
        </li>
        <li class="">
          <a
            href="https://twitter.com/trailfinderscc?lang=en"
            target="_blank"
            class=""
            ><i class="zmdi zmdi-twitter"
          /></a>
        </li>
        <!-- Contact -->
        <li class="border-left">
          <a href="mailto:cricket@ealingtcc.com" class=""
            ><i class="material-icons">email</i></a
          >
        </li>
        <li class="border-left">
          <a href="https://goo.gl/maps/1mtTgADiPDM2" target="_blank" class=""
            ><i class="material-icons">location_on</i></a
          >
        </li>
        <li class="border-left">
          <a
            href="https://www.hawkinsport.co.uk/clubs/cricket-clubs/ealing-trailfinders"
            target="_blank"
            class=""
            >SHOP</a
          >
        </li>
        <!-- Members -->
        <li class="list-inline-item dropdown border-left ml-auto d-none">
          <a
            class="dropdown-toggle dropdown-toggle-members"
            href="#"
            id="navbarDropdownMembers"
            role="button"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            <span class="text-small px-2">Memebers</span>
            <i class="material-icons icon-4">supervised_user_circle</i>
          </a>

          <!-- dropdown -->
          <div
            class="dropdown-menu dropdown-menu-right dropdown-members"
            aria-labelledby="navbarDropdownMembers"
          >
            <form>
              <!--<div class="form-group">-->
              <!--<input type="email" class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" placeholder="Username">-->
              <!--</div>-->
              <!--<div class="form-group">-->
              <!--<input type="password" class="form-control" id="exampleInputPassword1" placeholder="Password">-->
              <!--</div>-->

              <div class="form-group">
                <div class="input-group">
                  <div class="input-group-prepend">
                    <div class="input-group-text">
                      <i class="material-icons"> alternate_email </i>
                    </div>
                  </div>
                  <input
                    type="email"
                    class="form-control"
                    id="inlineFormUsername"
                    placeholder="Username"
                  />
                </div>
              </div>
              <div class="form-group">
                <div class="input-group">
                  <div class="input-group-prepend">
                    <div class="input-group-text">
                      <i class="material-icons"> lock </i>
                    </div>
                  </div>
                  <input
                    type="password"
                    class="form-control"
                    id="inlineFormPassword"
                    placeholder="Password"
                  />
                </div>
              </div>

              <button type="submit" class="btn btn-dark btn-lg btn-block">
                Login
              </button>
            </form>

            <div class="alert alert-light m-0">
              <a class="btn btn-link" href="#">Forgot password?</a>
            </div>
          </div>
        </li>
      </ul>
    </div>

    <!-- NAVBAR -->
    <nav class="navbar navbar-expand-md navbar-dark bg-dark">
      <!-- Mogile Logo -->
      <div class="mobile-nav">
        <a v-bind:href="'#/'" class="tfcc-logo navbar-brand">
          <img src="../assets/img/logo-tfcc.svg" class="img-fluid" alt="" />
          <span>Ealing Trailfinders Cricket Club</span>
        </a>

        <!-- Toggler -->
        <button
          class="navbar-toggler ml-auto"
          @click="handleClick"
          type="button"
          data-toggle="collapse"
          data-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span class="navbar-toggler-icon" />
        </button>
      </div>
      <!-- Responsive Navigation -->
      <div :class="mobileNav" id="navbarSupportedContent">
        <div class="row no-gutters justify-content-between m-auto">
          <!-- Nav Left -->
          <div class="col-12 col-md-auto">
            <ul class="navbar-nav">
              <li class="nav-item">
                <a class="nav-link" v-bind:href="'/'">
                  Home 
                  <span class="sr-only">(current)</span></a
                >
              </li>
              <li class="nav-item">
                <a class="nav-link" v-bind:href="'#/adults'">
                  Adults
                  <span class="sr-only">(current)</span>
                </a>
              </li>
            <li class="nav-item">
                <a class="nav-link" v-bind:href="'#/juniors'">
                  Juniors
                  <span class="sr-only">(current)</span>
                </a>
              </li>

            </ul>
          </div>

          <!-- Logo -->
          <div class="col has-tfcc-logo">
            <a v-bind:href="'#/'" class="tfcc-logo">
              <img src="../assets/img/logo-tfcc.svg" class="img-fluid" alt="" />
            </a>
          </div>

          <!-- Nav Right -->
          <div class="col-12 col-md-auto">
            <ul class="navbar-nav">
              <li class="nav-item">
                <a class="nav-link" v-bind:href="'#/about'">
                  About
                  <span class="sr-only">(current)</span>
                </a>
              </li>
              <li class="nav-item">
                <a v-bind:href="'#/news'" class="nav-link">News</a>
              </li>
              <li class="nav-item">
                <a v-bind:href="'#/contact'" class="nav-link">Contact</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </nav>
  </header>
</template>
<script>
export default {
  data() {
    return {
      mobileNav: "collapse navbar-collapse",
      clicked: false,
    };
  },
  methods: {
    handleClick() {
      if (!this.clicked) {
        this.clicked = true;
        this.mobileNav = "";
      } else {
        this.clicked = false;
        this.mobileNav = "collapse navbar-collapse";
      }
    },
  },
};
</script>
<style>
.mobile-nav {
  width: 100%;
  display: flex;
  justify-content: space-between;
}

.navbar {
  display: flex !important;
  flex-direction: column !important;
}
</style>
